// DateFormat.js
export function formatDate(dateString) {
    if (!dateString) return "";

  const date = new Date(dateString);

  return date.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short", // "May"
    year: "numeric",
  }).replace(",", ""); // removes comma between month and year
  }
  